'use client'

import { useMemo } from 'react'
import clsx from 'clsx'
import { usePathname } from 'next/navigation'

import { PATHS } from 'shared/utils/paths'

import { CartPageType, CartPorts } from '../../../ports'

import CartPricingSummary from './CartPricingSummary'

import styles from './CartSummary.module.scss'

const CartSummary = ({
  destination,
  isCartDrawer = false,
  isRibbonActive = false,
  handleModalClose,
  ports
}: {
  destination: string
  isCartDrawer?: boolean
  isRibbonActive?: boolean
  handleModalClose?: () => void
  ports: CartPorts
}) => {
  const pathname = usePathname()

  const pageType = useMemo((): CartPageType => {
    switch (pathname) {
      case PATHS.delivery:
        return 'delivery'
      case PATHS.payment:
        return 'payment'
      case PATHS.cart:
      default:
        return 'cart'
    }
  }, [pathname])

  return (
    <div
      className={clsx(styles.summaryFloatingWrapper, {
        [styles.withRibbon]: isRibbonActive && !isCartDrawer,
        [styles.cartDrawer]: isCartDrawer
      })}
    >
      <ports.EditSaleOrderNotice pageType={pageType} variant='banner' />
      <div className={styles.summaryWrapper}>
        {destination !== 'cart' && (
          <div className={styles.webContent}>
            <div className={styles.sectionTitle}>Podsumowanie</div>
          </div>
        )}
        <CartPricingSummary
          destination={destination}
          isCartDrawer={isCartDrawer}
          handleModalClose={handleModalClose}
          ports={ports}
        />
      </div>
    </div>
  )
}

export default CartSummary
